import {Button, Form, Input} from 'antd';
import React, {useEffect, useState} from 'react';
import {Arguments} from '../common/Arguments';
import {GetOrgData} from '../common/ApiMethod';
import OnFinishMethod from '../common/OnFinishMethod';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 8, span: 16},
};

const PartyOfficeAdmin = () => {
	const [form] = Form.useForm();
	const [currentRecord, setCurrentRecord] = useState([]);
	const [saveButton, setSaveButton] = useState(false);
	const getApi = Arguments.host + '/society_organization/party/consortium/api!partyOffice.do';
	const postApi = [Arguments.host + '/society_organization/party/consortium/api!addPartyOffice.do'];
	const orgId = (parseInt(sessionStorage.getItem('coffee')) / 20).toString();

	// 根据 organization_id 选择初始数据
	useEffect(() => {
		GetOrgData(getApi).then(finalResult => {
			form.setFieldsValue(finalResult);
			setCurrentRecord({organizationId: orgId, ...finalResult});
		});
	}, [getApi]);

	const onFinish = (data) => {
		OnFinishMethod({...currentRecord, ...data}, postApi);
		setTimeout(() => setSaveButton(true), 500);
	};

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			style={{maxWidth: 800, marginLeft: 15}}
		>
			<Form.Item name="officeAddress" label="办公地址" rules={[{required: true, validator: validateWhiteSpace}]}>
				<Input/>
			</Form.Item>

			<Form.Item name="officeEmail" label="办公邮箱">
				<Input/>
			</Form.Item>

			<Form.Item name="officePeople1" label="联系人" rules={[{required: true, validator: validateWhiteSpace}]}>
				<Input/>
			</Form.Item>

			<Form.Item name="officePhone1" label="联系电话" rules={[{required: true, validator: validateWhiteSpace}]}>
				<Input/>
			</Form.Item>

			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit" disabled={saveButton}>
					保存
				</Button>
			</Form.Item>

		</Form>
	);
};

export default PartyOfficeAdmin;
